import React, { useState } from 'react';
import { Modal, Divider, Button, Grid, Image, Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import DefaultCategory from '../../drive/Categories/DefaultCategory';
import bulkOperation from '../../../images/common/bulk-operation.png'
import refImg from '../../../images/svg/noti-content.svg';
import Labels from '../../common/Labels';

const ContentInfoModal = ({ contentInfoModal, closeInfoModal, content, submitModal, categoryList, selectedAccount }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const submitInfoModal = () => {
        submitModal(selectedCategories);
    }
    const disableSubmitButton = selectedCategories.length !== 3
    return <Modal
        animated
        open={contentInfoModal}
        onClose={closeInfoModal}
        size='small'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
    >
        <Modal.Header>Import Content</Modal.Header>
        <Divider style={{ margin: "10px 0 0px" }} />
        <Modal.Content scrolling>
            <Form noValidate
                id='importPlaybook'
                onValidSubmit={(data) => submitInfoModal(data)}
                className="formcyForm"
            >
                <Message icon >
                    <Image src={refImg} height="12px" style={{ margin: "0 5px 0 0" }} />
                    <Message.Content> You are importing {content.contentCount} content in your workspace</Message.Content>
                </Message>
                {/* <strong>You are importing {content.contentCount} contents in your workspace</strong><br /> */}
                <strong>Assign Knowledge bank from your Workspace to all these content</strong>
                <DefaultCategory
                    allCategories={categoryList}
                    handleCategorySelection={setSelectedCategories}
                    pageLevel="import"
                    selectedAccount={selectedAccount} />
                <div style={{
                    float: "left",
                    display: "inline-block",
                    padding: "0 20px 0 0"
                }}>
                    <Labels
                        name="Note"
                        text={<Image src={bulkOperation} height="100px" />
                        }
                    />
                </div>
                <div className="fs_italic" style={{ margin: "52px 0 0 0" }} >
                    All the imported content will be placed under your Indesign content section.<br />You can change the Knowledge bank/Category/Sub-Category of single or multiple content by navigating to Content Manager and then using bulk operation &gt; Change category.
                </div>

            </Form>
        </Modal.Content>

        <Modal.Actions className="actionInFormcy">
            <Button
                className="button-submit float-right"
                id='importPlaybook'
                disabled={disableSubmitButton}
                onClick={submitInfoModal}
            > Import Now </Button>
            <Button
                id='copyCancel'
                className="button-cancel"
                onClick={closeInfoModal}
            > Cancel </Button>
        </Modal.Actions>
    </Modal >
}
export default ContentInfoModal;